import React from 'react';
import PanelInformationItem from "../../Atoms/Items/PanelInformationItem";
import EmployeeInformationContainer from "../Containers/EmployeeInformationContainer";

const PersonaInfromationData = () => {
  return (
    <EmployeeInformationContainer
      title="Datos personales"
      icon="user"
    >
      <PanelInformationItem title="Estado civil" text="Soltero" />
      <PanelInformationItem title="Género" text="Masculino" />
      <PanelInformationItem title="Teléfono" text="123 456 7890" />
      <PanelInformationItem title="Celular" text="123 456 7890" />
      <PanelInformationItem title="Celular" text="123 456 7890" />
      <PanelInformationItem title="Correo electrónico" text="juanalexismoraangulo@hotmail.com" twoColumns />
      <PanelInformationItem title="Domicilio" text="Prolongación Espino #8, Pueblo Nuevo, Xalisco" twoColumns />
    </EmployeeInformationContainer>
  );
};

export default PersonaInfromationData;
